// extracted by mini-css-extract-plugin
export default {"imageWrapper":"hM-z","twoColumnImage":"iM-z"};